export const settings = {
  selector: '.js-guide-download',
  responseSelector: '.js-form-response'
}

/**
 * Initialize all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Initialize single guide download form.
 * @param {DOMNode} element
 */
export function init( element ) {
  element.querySelector( 'form' ).addEventListener( 'submit', async function( e ) {
    e.preventDefault()
    const form = e.target
    const email = form.email.value
    const nonce = form.nonce.value
    const guide = form.guide_id.value
    const lang = document.documentElement.lang || 'fi'
    const responseEl = form.querySelector( settings.responseSelector )
    responseEl.textContent = '—'
    responseEl.classList.add( 'loading' )

    const res = await fetch( '/wp-json/sponda/v1/request-guide?lang=' + lang, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': nonce
      },
      body: JSON.stringify({ email, guide })
    })

    responseEl.classList.remove( 'loading' )
    responseEl.textContent = res.ok ? responseEl.dataset.success : responseEl.dataset.error
  })
}
